module.exports = __webpack_public_path__ + "static/img/logo_footer.4823c32c.png";